const auth = {
  "form": {
    "login": "Login",
    "signUp": "Sign Up",
    "email": "Email",
    "password": "Password",
    "passwordConfirm": "Confirm Password",
    "forgotPassword": "Forgot Password",
    "checkDuplicate": "Check Duplicate",
    "next": "Next",
    "previous": "Previous",
    "backToLogin": "Back to login",
    "showPassword": "Show password",
    "hidePassword": "Hide password",
    "id": "ID",
    "name": "Name",
    "phone": "Phone Number",
    "company": "Company",
    "job": "Job",
    "field": "Field",
    "userInfo": "User Information",
    "verificationCode": "Verification Code",
    "resending": "Resending...",
    "verifying": "Verifying...",
    "fieldOptions": {
      "design": "Design",
      "construction": "Construction",
      "maintenance": "Maintenance",
      "safetyInspection": "Safety Inspection",
      "survey": "Survey",
      "agriculture": "Agriculture",
      "environment": "Environment"
    }
  },
  "validation": {
    "emailRequired": "Please enter your email",
    "emailInvalid": "Invalid email format",
    "passwordRequired": "Please enter your password",
    "passwordConfirmRequired": "Please confirm your password",
    "passwordMinLength": "Password must be at least 8 characters",
    "nameRequired": "Please enter your name",
    "phoneRequired": "Please enter your phone number",
    "phoneInvalid": "Invalid phone number format",
    "companyRequired": "Please enter your company",
    "jobRequired": "Please enter your job",
    "fieldRequired": "Please select a field",
    "fieldPlaceholder": "Please select",
    "codeRequired": "Please enter the verification code",
    "codeSixDigits": "Please enter 6 digits"
  },
  "message": {
    "loginFailed": "Login failed.",
    "confirmFailed": "Confirmation is Failed",
    "resendingConfirmationCode": "Confirmation code is resend",
    "confirmationCodeResendingFail": "Resending is Failed",
    "fillEmail": "Please enter the email you used for registration.",
    "sendCodeNumber": "We will send you an authentication code.",
    "sentCodeNumber": "The authentication code has been sent.",
    "sendCodeNumberFailed": "Failed to send authentication code.",
    "changePassWordFailed": "Failed to change password.",
    "passwordChangeSuccess": "Password has been successfully changed.",
    "passwordChangeFailed": "Password Change Failed",
    "notMatchCode": "The authentication code consists of six digits.",
    "signUpFailed": "Sign up failed",
    "signupRetry": "We couldn't complete your sign-up. Please try again in a moment.",
    "finishingSignup": "Your sign-up was not finished. Finishing it now.",
    "verificationCodeSendFailed": "Verification Code Send Failed",
    "verificationCodeSendFailedMessage": "Failed to send verification code. Please try again.",
    "getVerificationCode": "Get Verification Code",
    "supersededNotice": "You have been logged out because the same account was logged in to this app on another device. Log in again to continue.",
    "supersededPartnerNotice": "You have been logged out because the same account was logged in to this app on another device. To continue, open DroneSquare again from Hi-board.",
    "claimSuperseded": "This account was logged in to this app more recently on another device. Please log in again.",
    "claimUnavailable": "We couldn't confirm your login. Please try again in a moment.",
    "autoLoginFailed": "Automatic login failed. Please try again."
  },
  "deviceConflict": {
    "title": "This account is in use on another device",
    "body": "An account can be logged in on only one device at a time in each app. If you log in here, the other device using this app will be logged out.",
    "cancel": "Cancel",
    "confirm": "Log in"
  }
} as const;

export default auth;
